import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { RoleSpecificAreaGroupsDefaultView } from './views/RoleSpecificAreaGroupsDefaultView';
import {
  RoleSpecificAreaGroupsInteractions,
  RoleSpecificAreaGroupsInteractionsProps,
} from './partials/RoleSpecificAreaGroupsInteractions';

export function RoleSpecificAreaGroups({ views, activeView }: RoleSpecificAreaGroupsInteractionsProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      return <RoleSpecificAreaGroupsInteractions views={views} activeView={activeView} />;
    default:
      return <RoleSpecificAreaGroupsDefaultView {...views.default} />;
  }
}

export const RoleSpecificAreaGroupsBlock = asFetchableBlock(RoleSpecificAreaGroups, BlockType.rolespecificareagroups);
export type RoleSpecificAreaGroupsBlock = ComponentProps<typeof RoleSpecificAreaGroupsBlock>;
